/**
 * 地图组件样式定义
 */

export const mapContainerStyle = (height: string | number, width: string | number) => ({
  position: 'relative' as const,
  height,
  width
});

export const mapStyle = {
  height: '100%',
  width: '100%',
  backgroundColor: '#f0f0f0' // 加载前的背景色
};

export const searchContainerStyle = {
  position: 'absolute' as const,
  top: '10px',
  left: '50px',
  zIndex: 1000,
  width: '300px',
  backgroundColor: 'white',
  borderRadius: '4px',
  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
  overflow: 'hidden' as const
};

export const searchInputStyle = {
  width: '100%',
  padding: '10px 40px 10px 10px',
  border: 'none',
  outline: 'none',
  fontSize: '14px',
  boxSizing: 'border-box' as const
};

export const searchButtonStyle = {
  position: 'absolute' as const,
  right: '5px',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '5px',
  color: '#666'
};

export const searchResultsStyle = {
  maxHeight: '200px',
  overflowY: 'auto' as const,
  borderTop: '1px solid #eee'
};

export const searchResultItemStyle = {
  padding: '10px',
  borderBottom: '1px solid #eee',
  cursor: 'pointer',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: '#f5f5f5'
  }
};

export const locationInfoStyle = {
  position: 'absolute' as const,
  bottom: '10px',
  left: '10px',
  backgroundColor: '#000000',
  opacity: 0.6,
  padding: '10px 15px',
  borderRadius: '4px',
  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
  maxWidth: '80%',
  zIndex: 1000
};

export const locationInfoContentStyle = {
  display: 'flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'space-between' as const
};

export const locationTextStyle = {
  marginRight: '30px'
};

export const closeButtonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: 'bold' as const
};

export const locateButtonStyle = {
  backgroundSize: '20px 20px',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: '30px'
};

export const toggleButtonStyle = {
  width: '100%',
  padding: '8px',
  backgroundColor: '#f5f5f5',
  border: 'none',
  borderTop: '1px solid #eee',
  cursor: 'pointer',
  fontSize: '12px',
  textAlign: 'center' as const,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#666'
}
export const locateButtonDisplayStyle = {
  height: '30px',
  display: 'block'
};